import constants from './constants';

const initState = {
  isEditBenchmarkContributionDialogOpen: false,
  isThankyouDialogOpen: false,
  benchmark: null,
}

export default function (state = initState, action) {
    switch(action.type) {
      case constants.MUTUAL_AID_OPEN_EDIT_BENCHMARK_CONTRIBUTION_DIALOG:
        return {
            ...state,
            isEditBenchmarkContributionDialogOpen: true,
        }
      case constants.MUTUAL_AID_CLOSE_EDIT_BENCHMARK_CONTRIBUTION_DIALOG:
        return {
          ...state,
          isEditBenchmarkContributionDialogOpen: false,
        }
      case constants.MUTUAL_AID_SET_CONTRIBUTION_BENCHMARK:
        return {
          ...state,
          benchmark: action.payload,
        }
      case constants.MUTUAL_AID_OPEN_THANKYOU_DIALOG:
        return {
          ...state,
          isThankyouDialogOpen: true,
        }
      case constants.MUTUAL_AID_CLOSE_THANKYOU_DIALOG:
        return {
          ...state,
          isThankyouDialogOpen: false,
        }
      default:
        return state;
    }
}